import { createElement, ReactNode } from 'react';
import { Colorway } from '@uds/theme-utils';

import useStylesheet from './Heading.stylesheet';

interface OuterProps {
  colorway: Colorway;
  level: number;
  children?: ReactNode;
}

const PureHeading = ({ children, level, colorway }: OuterProps) => {
  const { styles } = useStylesheet({
    level,
    colorway,
  });

  return createElement(`h${level}`, { style: styles.root }, children);
};

PureHeading.displayName = 'LegalDocumentHeading';

// const Heading = ({ colorway, ...props }: OuterProps) => PureHeading({ colorway, ...props });

export default PureHeading;
